import { useEffect, useState } from "react";
import dayjs from 'dayjs';

function formatPrice(price) {
    return new Intl.NumberFormat('en-US').format(price);
}

function returnStringByLang(obj, lang) {
    const { kurdishName, englishName, arabicName } = obj;
    let returnString = '';

    switch (lang) {
        case 'en':
            returnString = englishName;
            break;
        case 'ku':
            returnString = kurdishName;
            break;
        case 'ar':
            returnString = arabicName;
            break;

        default:
            returnString = '';
            break
    }
    return returnString;
}

function returnTitleByLang(obj, lang) {
    const { titleKurdish, titleEnglish, titleArabic } = obj;
    let returnString = '';

    switch (lang) {
        case 'en':
            returnString = titleEnglish;
            break;
        case 'ku':
            returnString = titleKurdish;
            break;
        case 'ar':
            returnString = titleArabic;
            break;

        default:
            returnString = '';
            break
    }
    return returnString;
}

function returnDescriptionByLang(obj, lang) {
    const { descriptionKurdish, descriptionEnglish, descriptionArabic } = obj;
    let returnString = '';

    switch (lang) {
        case 'en':
            returnString = descriptionEnglish;
            break;
        case 'ku':
            returnString = descriptionKurdish;
            break;
        case 'ar':
            returnString = descriptionArabic;
            break;

        default:
            returnString = '';
            break
    }
    return returnString;
}

const useWindowSize = () => {
    const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });

    useEffect(() => {
        const handleResize = () => setSize({ width: window.innerWidth, height: window.innerHeight });
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return size;
};

const getTimeStringPdf = (time, t) => {
    if (!time) return '';
    switch (time.time) {
        case 'today':
            return t.today;
        case 'yesterday':
            return t.yesterday;
        case 'daybeforeyesterday':
            return t.daybeforeyesterday;
        case 'week':
            return t.week;
        case 'month':
            return t.month;
        case 'custom':
            return `${dayjs(time.from).format('DD/MM/YYYY')} - ${dayjs(time.to).format('DD/MM/YYYY')}`;
        default:
            return (time.from && time.to)
                ? `${dayjs(time.from).format('DD/MM/YYYY')} - ${dayjs(time.to).format('DD/MM/YYYY')}` : '';
    }
};

const getTimeStringPdfDates = (time, t) => {
    if (!time) return '';

    const formatDate = (date) => dayjs(date).format('DD/MM/YYYY');
    const now = dayjs();

    switch (time.time) {
        case 'today':
            return formatDate(now);

        case 'yesterday':
            return formatDate(now.subtract(1, 'day'));

        case 'daybeforeyesterday':
            return formatDate(now.subtract(2, 'day'));

        case 'week':
            // start of the week (Monday) to today
            return `${formatDate(now.startOf('week'))} - ${formatDate(now)}`;

        case 'month':
            // start of the month to today
            return `${formatDate(now.startOf('month'))} - ${formatDate(now)}`;

        case 'custom':
            return `${formatDate(time.from)} - ${formatDate(time.to)}`;

        default:
            return (time.from && time.to)
                ? `${formatDate(time.from)} - ${formatDate(time.to)}`
                : '';
    }
};


const getPostTypePdf = (type, t) => {
    if (!type) return '';
    switch (type) {
        case 'new':
            return t.new;
        case 'change':
            return t.change;
        default:
            return '';
    }
};

export {
    formatPrice,
    returnStringByLang,
    returnTitleByLang,
    returnDescriptionByLang,
    useWindowSize,
    getTimeStringPdf,
    getPostTypePdf,
    getTimeStringPdfDates
};
